export default __webpack_public_path__ + "static/media/asoulforourfeast1.14b09187.png";